'use client';

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate px-6">
      <div className="text-center max-w-md">
        <div className="text-8xl font-display font-bold text-navy opacity-10 mb-4">404</div>
        <div className="w-16 h-16 rounded-2xl bg-navy flex items-center justify-center mx-auto mb-6">
          <svg width="28" height="28" viewBox="0 0 18 18" fill="none">
            <path d="M9 2L3 6v6l6 4 6-4V6L9 2z" fill="#F5A623" />
          </svg>
        </div>
        <h2 className="font-display text-2xl font-bold text-navy mb-2">Page not found</h2>
        <p className="text-minikwa-muted mb-8 text-sm leading-relaxed">
          The page you are looking for does not exist. Let us get you back to practising.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => router?.back()}
            className="px-6 py-3 border-2 border-navy text-navy rounded-full font-semibold text-sm hover:bg-navy hover:text-slate transition-all"
          >
            Go Back
          </button>
          <Link
            href="/home"
            className="px-6 py-3 bg-navy text-slate rounded-full font-semibold text-sm hover:bg-navy-light transition-all"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}